import * as classes from './Button.module.css';
//import fetchUserMLResults from 'fetchML/fetch_hive_ml_diagnosis';

//import LoginButton from "./auth/login"
import fetchUserMLResults from "./fetchML/fetch_hive_ml_diagnosis"

/*
(() =>{
  await fetchUserMLResults('hi');
})();
*/


// todo: import. This is some reapeated function, 3 times.
function log_error3(error_str, e) {
  console.error('exception caught:', e);
  document.body.append(error_str);
  document.body.append('     \n     ');
}

export function Button({ children }) {

  return (
    // className="classes.button" <-- does not work
    <button className={classes.button}
      // This button in general is not suposed to have it. But eight now I am using it just as aa debugger
      onClick={async () => {

        //const r = 'results are not loaded';
        // Why shows error?!!!!
        const r = await fetchUserMLResults('sosi');
        console.log(r);
        // alert('BE:' + r);

        // log_error3();

        // todo: log them in the bottom of the page
        // post process
        // r is an array
        const rstr = r.map(json => {
          try {
          const cols = [json.results[0], json.results[1], json.durationMS, json.filename, json.globally_unique_job_id];
          if(json.failed) {
            return '(failed)' + cols.join(' ');
          }
          console.log(cols.join(' '));
          return cols.join(' ');
          } catch (e) {
            log_error3(e);
            return ['err1', 'err2', -1, 'err-fn'].join(' ');
          }
        }).join('\n       <br/> ------- \n')
        document.body.append(rstr);
      }}
    >
      {children}
    </button>
  );
}
